import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-import-result-dialog',
  templateUrl: './import-result-dialog.component.html',
  styleUrls: ['./import-result-dialog.component.scss']
})
export class ImportResultDialogComponent {

  titulo: string = 'Resultado de la importación';

  gridArray: any;
  headArray: any = [
    {
      Head: 'Errores',
      FieldName: 'error',
      Maxtext: 9999
    }
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
public dialogRef: MatDialogRef<ImportResultDialogComponent>) {
    this.gridArray = this.data?.map((msg: string) => ({ error: this.parseErrorMessage(msg) }));
  }

  private parseErrorMessage(msg: string): string {
    const marker = 'EnvaloraException: ';
    return msg.replace(/[\w.]+EnvaloraException:\s*/g, '');
  }

      closeDialog(): void {
    this.dialogRef.close();
  }
}
